<script setup lang="ts">
import { useEventsFilters } from '../lib/useEventsFilters';
import { EVENT_VIEW_MODES } from '~/shared/lib/events-routes.const';
import EventsTopBar from './EventsTopBar.vue';
import EventsSubTabs from './EventsSubTabs.vue';
import EventsAfisha from './afisha/EventsAfisha.vue';
import EventsMediaGalleries from './media-galleries/EventsMediaGalleries.vue';
import EventsSchedule from './schedule/EventsSchedule.vue';
import { useEventsSeo } from '../lib/seo';

const { timeFilter, viewMode, mediaMode, setTimeFilter, setViewMode } =
  useEventsFilters();

useEventsSeo({ viewMode, mediaMode, timeFilter });
</script>

<template>
  <div :class="$style.page">
    <EventsTopBar
      :time-filter="timeFilter"
      :show-time-filter="viewMode === EVENT_VIEW_MODES.afisha"
      @change-time-filter="setTimeFilter"
    />
    <EventsSubTabs :active="viewMode" @change="setViewMode" />

    <EventsAfisha v-if="viewMode === EVENT_VIEW_MODES.afisha" />
    <EventsMediaGalleries v-if="viewMode === EVENT_VIEW_MODES.media" />
    <EventsSchedule v-if="viewMode === EVENT_VIEW_MODES.schedule" />
  </div>
</template>

<style module lang="scss">
.page {
  display: flex;
  flex-direction: column;
  background-color: var(--color-white);
}
</style>
